module.exports = __webpack_public_path__ + "static/img/34.a8c7064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/34.png
// module id = /ccE
// module chunks = 0